import { usePlayground } from "@/components/Playground/playground-store";
import { useAuth } from "@/context/auth-context";

export const useEvaluateScope = () => {
  const playground = usePlayground();
  const auth = useAuth();

  return {
    playground,
    queryScope: {
      userToken: auth?.userToken || "",
      workspaceId: playground.workspace_id,
      sessionId: playground.instanceId,
    },
  };
};
